import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import CheckIcon from 'mdi-material-ui/Check';
import TruckFastIcon from 'mdi-material-ui/TruckFast';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { palette } from 'theme';

const ProductCard = styled(Card)`
  margin-bottom: 2em;
`;

const SpacedCardActions = styled(CardActions)`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1em;
`;

const CardHeaderItem = styled.div`
  display: flex;
  align-items: center;
`;

const MutedHintTypography = styled(Typography)`
  font-weight: bold;
  font-size: 14px;
  margin: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: 10px;
  }
`;

const ProductIcon = styled.img`
  width: 48px;
  height: 48px;
  margin-right: 10px;
`;

const DenseListItemIcon = styled(ListItemIcon)`
  margin-right: 0;
  width: 16px;
  height: auto;
`;

const SmallCheckIcon = styled(CheckIcon)`
  color: ${palette.primary.main};
  width: 18px;
  height: 18px;
`;

const LessPaddedDivider = styled(Divider)`
  margin: 1em 0;
`;

class WideProductCard extends React.PureComponent {
  render() {
    const {
      name,
      iconurl,
      shortDescription,
      cta,
      moreLink,
      benefits,
      features,
      includes,
      listPrice,
      shippingSpeed
    } = this.props;

    return (
      <ProductCard>
        <CardContent>
          <Grid
            container
            justify="space-between"
            align-items="center"
            spacing={0}
          >
            <Grid item>
              <CardHeaderItem>
                <ProductIcon src={iconurl} alt="" />
                <Typography variant="h5" noWrap>
                  {name}
                </Typography>
              </CardHeaderItem>
            </Grid>
            <Grid item>
              <CardHeaderItem>
                <MutedHintTypography variant="body1">
                  <TruckFastIcon /> {shippingSpeed}
                </MutedHintTypography>
                <Typography variant="h5" align="center">
                  {listPrice}
                </Typography>
              </CardHeaderItem>
            </Grid>
          </Grid>
          {benefits && features && includes && (
            <>
              <LessPaddedDivider />
              <Grid container>
                <Grid item xs={12} md={4}>
                  <Typography variant="overline">Benefits</Typography>
                  <List dense>
                    {benefits.map((benefit, idx) => (
                      <ListItem key={idx} disableGutters>
                        {benefit.file && (
                          <DenseListItemIcon>
                            <img src={benefit.file.url} alt="" />
                          </DenseListItemIcon>
                        )}
                        <ListItemText>{benefit.name}</ListItemText>
                      </ListItem>
                    ))}
                  </List>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="overline">Features</Typography>
                  <List dense>
                    {features.map((benefit, idx) => (
                      <ListItem key={idx} disableGutters>
                        {benefit.file && (
                          <DenseListItemIcon>
                            <img src={benefit.file.url} alt="" />
                          </DenseListItemIcon>
                        )}
                        <ListItemText>{benefit.name}</ListItemText>
                      </ListItem>
                    ))}
                  </List>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography variant="overline">Includes</Typography>
                  <List dense>
                    {includes.map((benefit, idx) => (
                      <ListItem key={idx} disableGutters>
                        {benefit.file ? (
                          <DenseListItemIcon>
                            <img src={benefit.file.url} alt="" />
                          </DenseListItemIcon>
                        ) : (
                          <SmallCheckIcon />
                        )}
                        <ListItemText>{benefit.name}</ListItemText>
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </Grid>
            </>
          )}
          <LessPaddedDivider />
          <Typography variant="body2">{shortDescription}</Typography>
        </CardContent>
        <SpacedCardActions>
          {moreLink && (
            <Button color="primary" component={Link} to={moreLink}>
              Learn More
            </Button>
          )}
          {cta && (
            <Button color="primary" variant="raised" href={cta.cta_link}>
              {cta.cta_label || 'Order'}
            </Button>
          )}
        </SpacedCardActions>
      </ProductCard>
    );
  }
}

WideProductCard.propTypes = {
  name: PropTypes.string.isRequired,
  iconurl: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  cta: PropTypes.object,
  moreLink: PropTypes.string,
  benefits: PropTypes.array.isRequired,
  features: PropTypes.array.isRequired,
  includes: PropTypes.array.isRequired,
  listPrice: PropTypes.string.isRequired,
  shippingSpeed: PropTypes.string.isRequired
};

export default WideProductCard;
